export const PostChangeHostText = {
  successDescription: 'Perubahan Host Berhasil disimpan',
};
